module.exports = __webpack_public_path__ + "static/media/project-icon-white.e4176dae.svg";